import { TranslationLanguage } from '../translation/translation';
import { User } from '../user';

export namespace LanguageUtils {
  export function translationLanguageFromStorageString(string?: string) {
    if (!string) return;

    const language = string.slice(0, 2);
    const validLanguageMapping = {
      en: TranslationLanguage.en,
      lt: TranslationLanguage.lt,
      it: TranslationLanguage.it,
      ja: TranslationLanguage.ja,
      nl: TranslationLanguage.nl,
      de: TranslationLanguage.de,
    };
    if (Object.keys(validLanguageMapping).includes(language)) {
      const key = language as keyof typeof validLanguageMapping;
      return validLanguageMapping[key];
    }
  }

  export function translationLanguageFromUser(user?: User) {
    return translationLanguageFromStorageString(user?.language);
  }
}
